export const formatPrice = (price) => `$${price.toFixed(2)}`;
